export default __webpack_public_path__ + "static/media/external_trash.e27bc11e.svg";